
import React from 'react';
import { TestimonialsColumn, Testimonial } from './ui/testimonials-columns-1';
import { motion } from 'framer-motion';
import WordReveal from './WordReveal';
import Reveal from './Reveal';

const testimonials: Testimonial[] = [
  {
    text: "Venho falar, sobre a energy solaris, a assistência técnica que eles prestam. Só tenho a agradecer, sempre eles me ajudam, sempre dão assistência na hora que eu tô precisando.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Marlene",
    role: "Seabra / BA",
  },
  {
    text: "Os resultados de produção estão além daquilo que esperávamos. A atenção que a empresa tem dado, estamos muito satisfeitos mesmo, realmente os resultados são satisfatórios. A empresa está de parabéns.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Isaias",
    role: "Umburanas / BA",
  },
  {
    text: "A redução na conta de luz da nossa indústria foi imediata. O suporte pós-venda da Solaris é o grande diferencial no mercado baiano.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Ricardo Mendes",
    role: "Empresário - Gandu",
  },
  {
    text: "Instalamos na nossa fazenda e a autonomia é total. Tecnologia de ponta e equipe muito qualificada.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Antônio Silva",
    role: "Produtor Rural",
  },
  {
    text: "Melhor investimento que fizemos este ano. A parcela do financiamento é menor que a economia gerada.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Carla Souza",
    role: "Comerciante",
  },
  {
    text: "A transparência no projeto e a rapidez na homologação com a Coelba nos surpreendeu positivamente.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Marcos Oliveira",
    role: "Gestor de TI",
  },
  {
    text: "Excelente atendimento. Tiraram todas as dúvidas técnicas e o monitoramento via app funciona perfeitamente.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Beatriz Lins",
    role: "Arquiteta",
  },
  {
    text: "Recomendo a todos que buscam seriedade. A equipe de instalação é limpa, organizada e muito educada.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150&h=150",
    name: "José Ferreira",
    role: "Engenheiro Civil",
  },
  {
    text: "Nossa usina está produzindo 10% a mais que o projetado. A tecnologia N-Type realmente faz a diferença.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150",
    name: "Sônia Braga",
    role: "Investidora",
  },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 6);
const thirdColumn = testimonials.slice(6, 9);

const SocialProof: React.FC = () => {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="container z-10 mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          viewport={{ once: true }}
          className="flex flex-col items-center justify-center max-w-2xl mx-auto text-center mb-16"
        >
          <Reveal>
            <div className="flex justify-center mb-6">
              <div className="border border-[#39B54A]/20 py-1 px-4 rounded-full text-[10px] font-black uppercase tracking-[0.2em] text-[#39B54A] bg-[#39B54A]/5">
                Depoimentos Reais
              </div>
            </div>
          </Reveal>

          <h2 className="text-4xl md:text-5xl font-black tracking-tighter text-gray-900 leading-tight">
            <WordReveal text="O que nossos clientes dizem" delay={200} />
          </h2>
          <p className="mt-6 text-gray-500 font-medium text-lg">
            Confira a experiência de quem já transformou sua conta de energia em investimento com a Energy Solaris.
          </p>
        </motion.div>

        <div className="flex justify-center gap-6 mt-10 [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)] max-h-[700px] overflow-hidden">
          <TestimonialsColumn testimonials={firstColumn} duration={25} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={35} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={30} />
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
